/** @jsxImportSource @emotion/react */

import { memberApi } from "api/member";
import { VipPointsHistoryType } from "api/member/type";
import Loading from "components/ui/Loading";
import { ResponseCode } from "constants/response";
import { OrderStatus } from "enums/orders";
import { handleColorStatus, showStatusText } from "helpers/showStatusText";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectUsername } from "store/auth";

import { VipPointsHistoryStyle } from "./style";

const VipPointsHistory = () => {
  const { t } = useTranslation(["vip"]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dataTable, setDataTable] = useState<VipPointsHistoryType[]>([]);
  const username = useSelector(selectUsername);

  const fetchDataVIPPointHistory = async () => {
    try {
      setIsLoading(true);
      const res = await memberApi.VipPointsHistory(username);
      setIsLoading(false);
      if (res.status === ResponseCode.SUCCESS) {
        setDataTable(res.data);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (!username) return;
    fetchDataVIPPointHistory();
  }, [username]);

  return (
    <div css={VipPointsHistoryStyle.wrapper}>
      <div css={VipPointsHistoryStyle.title}>
        {t("VIPPointsHistory")} - {t("Turnover")}
      </div>
      {/* Table hide in MB */}
      <table css={VipPointsHistoryStyle.table}>
        <thead>
          <tr>
            <th style={{ width: "25%" }}>{t("VIPPoints")} (VP)</th>
            <th style={{ width: "20%" }}>{t("Amount")}</th>
            <th style={{ width: "20%" }}>{t("Remark")}</th>
            <th style={{ width: "20%" }}>{t("Date")}</th>
            <th style={{ width: "15%" }}>{t("Status")}</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr style={{ height: "200px" }}>
              <td colSpan={5}>
                <Loading />
              </td>
            </tr>
          ) : dataTable && dataTable.length > 0 ? (
            dataTable.map((item, index) => (
              <tr key={index}>
                <td style={{ width: "25%" }}>{item.vip_points}</td>
                <td style={{ width: "20%" }}>{item.amount}</td>
                <td style={{ width: "20%" }}>{item.remark || "--"}</td>
                <td style={{ width: "20%" }}>{item.created_date}</td>
                <td style={{ width: "15%" }}>
                  <div
                    css={VipPointsHistoryStyle.statusOrder(
                      handleColorStatus(Number(item.status))
                    )}
                  >
                    {showStatusText(Number(item.status) as OrderStatus)}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr style={{ height: "200px" }}>
              <td colSpan={5}>{t("NoData")}</td>
            </tr>
          )}
        </tbody>
      </table>
      {/* card hide in dessktop */}
      <div css={VipPointsHistoryStyle.cardHistory}>
        {isLoading ? (
          <div className="loading-box">
            <Loading />
          </div>
        ) : dataTable && dataTable.length > 0 ? (
          dataTable.map((item, index) => (
            <div key={index} className="card">
              <div className="card-head">
                <div className="card-amount">
                  <p className="card-label">{t("Amount")}:</p>
                  <span className="card-value">{item.amount}</span>
                </div>
                <div
                  css={VipPointsHistoryStyle.statusOrder(
                    handleColorStatus(Number(item.status))
                  )}
                >
                  {showStatusText(Number(item.status) as OrderStatus)}
                </div>
              </div>
              <div className="card-body">
                <div className="card-title">
                  <div className="card-label">{t("VIPPoints")}:</div>
                  <div className="card-value">{item.vip_points}</div>
                </div>
                <div className="card-title">
                  <div className="card-label">{t("TableCustom:Remark")}:</div>
                  <div className="card-value">{item.remark || " ..."}</div>
                </div>
                <div className="card-title card-date">
                  <div className="card-label">{t("TableCustom:Date")}:</div>
                  <div className="card-value">{item.created_date}</div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">{t("NoData")}</div>
        )}
      </div>
    </div>
  );
};
export default VipPointsHistory;
